import React, {useEffect} from "react";
import s from './geoStatistics.module.scss'
import {useDispatch, useSelector} from "react-redux";
import {dashboardSelector} from "../../../../../redux/slices/dashboardSlice";
import {dashboardAppsColumnsList, dashboardGeosColumnsList} from "../../../../../utils/vars/params";
import {useTranslation} from "react-i18next";
import EmptyList from "../../../../../components/EmptyList/EmptyList";
import CustomSkeleton from "../../../../../components/UiKit/CustomSkeleton/CustomSkeleton";
import {fetchGeosList, globalDataSelector} from "../../../../../redux/slices/globalDataSlice";
import {colorList} from "../../../../../utils/vars/staticVariables";

const GeoStatistics = () => {

    const {topGeosList, topGeosPending} = useSelector(dashboardSelector)
    const {geoList} =
        useSelector(globalDataSelector);

    const dispatch = useDispatch();
    const {t} = useTranslation()

    useEffect(() => {
        dispatch(fetchGeosList());
    }, [dispatch]);

    const thead = <thead>
    <tr>
        {dashboardGeosColumnsList.map(({name}) => (
            <th key={name}>
                <div className={s.headerContent}>
                    {t(name)}
                </div>
            </th>
        ))}
    </tr>
    </thead>

    return (
        <div className={s.geoStatisticsContainer}>

            {
                topGeosList.length === 0 && !topGeosPending ? (
                    <EmptyList/>
                ) : topGeosPending ? (
                    <section className={s.body}>
                        <table>
                            {thead}
                        </table>
                        <div className={s.skeletonWrapper}>
                            <CustomSkeleton styles={s.skeletonTable}/>
                        </div>
                    </section>
                ) : (
                    <section className={s.body}>
                        <table>
                            {thead}
                            <tbody>
                            {
                                topGeosList.map((item, index) => {
                                    const {
                                        clicks_count,
                                        installs,
                                        leads,
                                        percentage,
                                        sales,
                                        unique_clicks,
                                        geo
                                    } = item

                                    const geoFlag = geoList.find(
                                        (geoItem) => geoItem.code === geo,
                                    )?.flag;

                                    return (
                                        <tr key={geo}>
                                            <td className={s.percentageTd}>{percentage}%</td>
                                            <td className={s.geoTd}>
                                                <span
                                                    className={s.colorDot}
                                                    style={{background: colorList[index]}}
                                                ></span>

                                                <span className={s.value}>
                              <span
                                  className={s.flagWrapper}
                                  style={
                                      geoFlag
                                          ? {
                                              backgroundImage: `url(${geoFlag})`,
                                          }
                                          : {
                                              background: "grey",
                                          }
                                  }
                              ></span>
                              <span>{geo}</span>
                            </span>
                                            </td>
                                            <td>{clicks_count}</td>
                                            <td>{unique_clicks}</td>
                                            <td>{installs}</td>
                                            <td>{leads}</td>
                                            <td>{sales}</td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </section>
                )
            }
        </div>
    )
}

export default GeoStatistics;